// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__-VV9G","rotate":"loader_rotate__KwP0X"};